<template>
    <div class="wrapper" style="min-width: 768px;" v-if="device == 'desktop'">
        <div class="bg"></div>
        <div class="header clearfix home-header">
            <div class="main-content">
                <a href="/" class="left logo router-link-active">
                    <img alt="LOGO" data-src="@/assets/img/logo_word_zh.7d8620d0.png"
                        src="@/assets/img/logo_word_zh.7d8620d0.png" lazy="loaded">
                </a>
                <div class="right">
                    <a href="/" class="ritem router-link-active"> 主页 </a>
                    <a href="#/promoters" class="ritem router-link-active"> 推广赚现金 </a>
                </div>
            </div>
        </div>
        <div class="main home-main zh">
            <div class="main-content clearfix">
                <div class="left">
                    <h1 class="slogon new_db zh">永远能连上的VPN </h1>
                    <ul class="desc">
                        <li><strong>3</strong>s <span>极速连接</span></li>
                        <li><strong>72</strong>h <span>免费试用</span></li>
                        <li><strong>1000</strong>+ <span>应用支持</span></li>
                    </ul>
                    <div class="down-wrapper">
                        <a href="javascript:void(0)" class="down_windows btn-down trace-download"
                            @click.prevent="downloadKP('windows')">
                            <i class="icon-windows"></i>
                            <span> PC 版下载 </span>
                        </a>
                        <a class="down-other btn-down" @click.prevent="scrollToSection('down-bot-wrapper')">
                            <img src="@/assets/img/phonelink.9925199c.svg" alt="">
                            <span>其他平台下载</span>
                        </a>
                    </div>
                </div>
                <div class="right">
                    <div class="appshow">
                        <img style="width: 96%;" src="@/assets/img/imghome_right_zh.60e1c05c.60e1c05c.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="app-ani">
            <div class="appAnimation pc">
                <h1 class="zh">全球热门应用 “任您畅玩”</h1><svg width="1000pt" height="500pt" viewBox="0,0,800,550"
                    preserveAspectRatio="xMidYMid meet" class="iehide showSvg">
                    <g class="blingcircle">
                        <circle cx="300pt" cy="200pt" r="80pt" stroke-width="2" stroke="rgba(100,128,253,0.15)"
                            fill="none">
                        </circle>
                        <circle cx="300pt" cy="200pt" r="130pt" stroke-width="2" stroke="rgba(100,128,253,0.1)"
                            fill="none">
                        </circle>
                        <circle cx="300pt" cy="200pt" r="180pt" stroke-width="2" stroke="rgba(100,128,253,0.05)"
                            fill="none"></circle>
                    </g>
                    <g class="bling blingcircle">
                        <image xlink:href="@/assets/img/speed_app_1.54d47b5a.png" x="-50pt" y="280pt" width="140pt"
                            height="140pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="260pt;-50pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="180pt;280pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_2.5dd0814b.png" x="0pt" y="100pt" width="80pt"
                            height="80pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="260pt;0pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="160pt;100pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_3.6b50eb2d.png" x="70pt" y="240pt" width="120pt"
                            height="120pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="260pt;70pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="160pt;160pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_4.5829ddd5.png" x="400pt" y="280pt" width="90pt"
                            height="90pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="260pt;400pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="160pt;280pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_5.217178c9.png" x="480pt" y="140pt" width="120pt"
                            height="120pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="260pt;480pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="160pt;140pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_6.fdc25fa8.png" x="550pt" y="280pt" width="140pt"
                            height="140pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="260pt;550pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="160pt;280pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                    </g>
                    <g class="bling blingcircle">
                        <defs data-v-e5f3c122="">
                            <linearGradient id="redbot" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style="stop-color: rgb(234, 67, 53);"></stop>
                                <stop offset="100%" style="stop-color: rgb(234, 67, 53);"></stop>
                            </linearGradient>
                        </defs>
                        <defs data-v-e5f3c122="">
                            <linearGradient id="bluebot" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style="stop-color: rgb(0, 102, 217); stop-opacity: 1;"></stop>
                                <stop offset="100%" style="stop-color: rgb(0, 102, 217); stop-opacity: 1;"></stop>
                            </linearGradient>
                        </defs>
                        <defs data-v-e5f3c122="">
                            <linearGradient id="yellowbot" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style="stop-color: rgb(255, 170, 69); stop-opacity: 1;"></stop>
                                <stop offset="100%" style="stop-color: rgb(255, 170, 69); stop-opacity: 1;"></stop>
                            </linearGradient>
                        </defs>
                        <circle cx="-30pt" cy="180pt" r="4pt" fill="url(#bluebot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;40pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;100pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                        <circle cx="170pt" cy="260pt" r="8pt" fill="url(#yellowbot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;40pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;210pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                        <circle cx="400pt" cy="140pt" r="2pt" fill="url(#redbot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;40pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;210pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                        <circle cx="520pt" cy="280pt" r="4pt" fill="url(#bluebot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;40pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;140pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                    </g><svg width="600pt" height="600pt" x="-2pt" class="ellip">
                        <g data-v-e5f3c122="">
                            <image xlink:href="@/assets/img/appAnimation.a744ae10.png" width="100pt" height="100pt"
                                x="252pt" y="150pt" class="hiddensvg enimgsvg svgimage"></image>
                        </g>
                    </svg>
                </svg>
            </div>
        </div>
        <div class="intro-wrapper">
            <div class="main-content clearfix">
                <div class="intro-item clearfix">
                    <div class="left aniLeft" data-sr-id="0">
                        <div class="desc-text">
                            <div class="tip_btn">
                                <img alt="" class="icon-desc-title" data-src="@/assets/img/home_title_img.a9313b31.png"
                                    src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded"><span>火爆卖点</span>
                            </div>
                            <h2> 一键“鲲鹏”，纵享丝滑 </h2>
                            <p>鲲鹏 VPN 采用全新内核，AI 智能连接，自动为您匹配全球最快的网络节点，只需要轻点“开启鲲鹏”，3秒之内，纵享丝绸般顺滑的冲浪体验。</p>
                        </div>
                    </div>
                    <div class="right aniRight" data-sr-id="6">
                        <img alt="" class="desc-img" data-src="@/assets/img/home_introduce_1.4974b5ba.png"
                            src="@/assets/img/home_introduce_1.4974b5ba.png" lazy="loaded">
                    </div>
                </div>
                <div class="intro-item clearfix">
                    <div class="left aniLeft" data-sr-id="2">
                        <img alt="" class="desc-img" data-src="@/assets/img/home_introduce_2.8e9af5ce.png"
                            src="@/assets/img/home_introduce_2.8e9af5ce.png" lazy="loaded">
                    </div>
                    <div class="right aniRight" data-sr-id="7">
                        <div class="desc-text">
                            <div class="tip_btn">
                                <img alt="" class="icon-desc-title" data-src="@/assets/img/home_title_img.a9313b31.png"
                                    src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded">
                                <span>火爆卖点</span>
                            </div>
                            <h2> 天涯海角，无不可达 </h2>
                            <p>鲲鹏 VPN 支持全球网络资源，无限制无记录的访问任何资源，同时使用最先进的技术帮助您抹除任何痕迹，真正实现天涯海角随处达。</p>
                        </div>
                    </div>
                </div>
                <div class="intro-item clearfix">
                    <div class="left aniLeft" data-sr-id="3">
                        <div class="desc-text">
                            <div class="tip_btn">
                                <img alt="" class="icon-desc-title" data-src="@/assets/img/home_title_img.a9313b31.png"
                                    src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded">
                                <span>火爆卖点</span>
                            </div>
                            <h2> 随用随享，永不套牢 </h2>
                            <p>全球唯一一家敢提供短期会员的知名 VPN，安全稳定的同时致力于保障用户权益，随时想用，随时订购，永远不用担心跑路，永远不用担心被套牢。</p>
                        </div>
                    </div>
                    <div class="right aniRight" data-sr-id="8">
                        <img alt="" class="desc-img" data-src="@/assets/img/home_introduce_3.63497ff8.png"
                            src="@/assets/img/home_introduce_3.63497ff8.png" lazy="loaded">
                    </div>
                </div>
                <div class="intro-item clearfix">
                    <div class="left aniLeft" data-sr-id="4">
                        <img alt="" class="desc-img" data-src="@/assets/img/home_introduce_4.82a6475d.png"
                            src="@/assets/img/home_introduce_4.82a6475d.png" lazy="loaded">
                    </div>
                    <div class="right aniRight" data-sr-id="9">
                        <div class="desc-text">
                            <div class="tip_btn">
                                <img alt="" class="icon-desc-title" data-src="@/assets/img/home_title_img.a9313b31.png"
                                    src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded">
                                <span>火爆卖点</span>
                            </div>
                            <h2> 不限平台，无缝衔接 </h2>
                            <p>鲲鹏 VPN 支持市面上所有主流的设备，只需一个账号即可在多个设备中共享会员，支持多设备同时在线，保障您不同使用场景下的无缝衔接。</p>
                        </div>
                    </div>
                </div>
                <div class="intro-item clearfix">
                    <div class="left aniLeft" data-sr-id="5">
                        <div class="desc-text">
                            <div class="tip_btn"><img alt="" class="icon-desc-title"
                                    data-src="@/assets/img/home_title_img.a9313b31.png"
                                    src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded"><span>火爆卖点</span></div>
                            <h2> 真人客服，永不失联 </h2>
                            <p>鲲鹏 VPN 提供 24 小时在线服务，100+ 真人客服与网络工程师随时待命，为您上网体验保驾护航，真真正正的提供随叫随到，永不失联的 VIP 服务。
                            </p>
                        </div>
                    </div>
                    <div class="right aniRight" data-sr-id="10"> <img alt="" class="desc-img"
                            data-src="@/assets/img/home_introduce_5.8e475357.png"
                            src="@/assets/img/home_introduce_5.8e475357.png" lazy="loaded">
                    </div>
                </div>
            </div>
        </div>
        <div class="comments">
            <div class="main-content clearfix">
                <h3 class="com-title">用户评价</h3>
                <!-- 用戶評價輪播 -->
                <div class="carousel-wrapper pc-comments-car">
                    <p class="comments">{{ comment }}</p>
                    <div class="carousel-container">
                        <span class="nav-arrow car-left" @click="changeSwiper(-1)"></span>
                        <span class="nav-arrow car-right" @click="changeSwiper(1)"></span>
                        <div class="carousel-ul-wrapper">
                            <ul class="carousel-content clearfix" :style="customStyles">
                                <li :data-index="index" class="carousel-item" style="width: 231.2px;"
                                    v-for="(item, index) in userComments" :key="index"
                                    :class="{ 'active': index == activeIndex }">
                                    <img :src="require('@/assets/user/' + item.img + '.png')" lazy="loading">
                                </li>
                                <li :data-index="index_1 + 27" class="carousel-item" style="width: 231.2px;"
                                    v-for="(item, index_1) in userComments" :key="index_1 + 27"
                                    :class="{ 'active': index_1 + 27 == activeIndex }">
                                    <img :src="require('@/assets/user/' + item.img + '.png')" lazy="loading">
                                </li>
                                <li :data-index="index_2 + 54" class="carousel-item" style="width: 231.2px;"
                                    v-for="(item, index_2) in userComments" :key="index_2 + 54"
                                    :class="{ 'active': index_2 + 54 == activeIndex }">
                                    <img :src="require('@/assets/user/' + item.img + '.png')" lazy="loading">
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="user-info">
                        <p>{{ user }}</p>
                        <p>{{ userCome }}</p>
                    </div>
                </div>
                <div class="cont">
                    <h3>立即免费试用</h3>
                    <div class="down-bot-wrapper" ref="down-bot-wrapper">
                        <div class="down-item">
                            <img alt="" class="app-img" src="@/assets/img/winpro-zh.6174ae51.png" lazy="loaded">
                            <a href="javascript:void(0)" class="down_windows btn-down trace-download"
                                @click.prevent="downloadKP('windows')">
                                <i class="icon-windows"></i>
                                <span>PC 版下载</span></a>
                        </div>
                        <div class="down-item"><img alt="" class="app-img" src="@/assets/img/zh-an.png" lazy="loaded">
                            <a href="javascript:void(0)" class="btn-down down_ios trace-download"
                                @click.prevent="downloadKP('ios')">
                                <i class="icon-ios"></i>
                                <span>iOS 版下载</span></a>
                        </div>
                        <div class="down-item"><img alt="" class="app-img" src="@/assets/img/zh-ios.png"
                                lazy="loaded"><a href="javascript:void(0)" class="down_android btn-down trace-download"
                                @click.prevent="downloadKP('android')">
                                <i class="icon-android">

                                </i>
                                <span>安卓版下载</span></a>
                        </div>
                        <div class="down-item">
                            <img alt="" class="app-img" data-src="@/assets/img/mac-zh.ce7d014a.png"
                                src="@/assets/img/mac-zh.ce7d014a.png" lazy="loaded">
                            <a href="javascript:void(0)" class="down_mac btn-down trace-download"
                                @click.prevent="downloadKP('macos')">
                                <i class="icon-ios"></i>
                                <span>Mac 版下载</span></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer>
            <div class="content clearfix topline">
                <div class="fleft">
                    <a href="/" class="bflogo router-link-active">
                        <img alt="" data-src="@/assets/img/logo_footer_zh.f421f1d9.png"
                            src="@/assets/img/logo_footer_zh.f421f1d9.png" lazy="loaded">
                    </a>
                    <div class="contact">
                        <span class="subtitle">联系我们：</span>
                        <a href="https://t.me/wudicms">
                            <img src="@/assets/img/email.2e4e9014.svg" alt="">
                        </a>
                        <!--<a href="https://twitter.com/letsvpn" target="_blank">
                            <img src="@/assets/img/twitter.9b53da9a.svg" alt="">
                        </a>
                        <a href="https://www.instagram.com/letsvpn/" target="_blank">
                            <img src="@/assets/img/ins.6c93479c.svg" alt="">
                        </a> -->
                    </div>
                    <p class="copyright">版权所有 © 2023 鲲鹏VPN 团队</p>
                </div>
                <div class="fright clearfix">
                    <div class="fritem down-platform">
                        <h3>下载客户端</h3>
                        <a href="javascript:void(0)" class="down_windows btn-down trace-download"
                            @click.prevent="downloadKP('windows')">
                            <span>PC 版本</span>
                        </a>
                        <a href="javascript:void(0)" class="down_android btn-down trace-download"
                            @click.prevent="downloadKP('android')">
                            <span>Android 版本</span>
                        </a>
                        <a href="javascript:void(0)" class="btn-down down_ios trace-download"
                            @click.prevent="downloadKP('ios')">
                            <span>iOS 版本</span>
                        </a>
                        <a href="javascript:void(0)" class="down_mac btn-down trace-download"
                            @click.prevent="downloadKP('macos')">
                            <span>Mac 版本</span>
                        </a>
                    </div>
                    <div class="fritem about">
                        <h3>关于鲲鹏</h3>
                        <a href="javascript:void(0)" class="helpCenter"> 帮助中心 </a>
                        <a href="javascript:void(0)" class="termservice">服务条款</a>
                        <a href="javascript:void(0)" class="privacy">隐私权政策</a>
                        <a href="javascript:void(0)" class="registerterm">注册协议</a>
                    </div>
                    <!-- <div class="fritem lng">
                        <h3>更换语言</h3>
                        <div class="ls-select-lng lng-select lng-size-default pc">
                            <div class="ls--dropdown ls--select-lng-dro top">
                                <div class="ls--dropdown-content"><label class="ls--select-lng-content"
                                        style="--text-color: rgba(116, 126, 139, 0.7); --hover-color: #747e8b;">
                                        <span class="show-text">简体中文</span><span class="caret"></span></label></div>
                                <div class="ls--dropdown-menu" style="display: none;">
                                    <div class="ls--dropdown-menu-item"><i style="display: none;"></i><span>简体中文</span>
                                    </div>
                                    <div class="ls--dropdown-menu-item"><i style="display: none;"></i><span>English</span>
                                    </div>
                                    <div class="ls--dropdown-menu-item"><i style="display: none;"></i><span>繁體中文</span>
                                    </div>
                                    <div class="ls--dropdown-menu-item"><i style="display: none;"></i><span>Русский</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </footer>
    </div>
    <!-- 手機端 -->
    <div class="m-wrapper" v-else>
        <div class="bg">
            <img src="@/assets/img/home_bg_tel.png" alt="">
        </div>
        <header class="header">
            <a href="/" class="left logo router-link-active">
                <img alt="LOGO" src="@/assets/img/logo_word_zh.7d8620d0.png" lazy="loaded">
            </a>
        </header>
        <div class="main">
            <h1 class="slogon new_db zh"> 永远能连上的VPN </h1><object data="@/assets/img/logo.75b26a2e.svg"
                class="svg_hid"></object>
            <ul class="desc">
                <li><strong>3</strong>s <span>极速连接</span></li>
                <li><strong>72</strong>h <span>免费试用</span></li>
                <li><strong>1000</strong>+ <span>应用支持</span></li>
            </ul>
            <div class="down-wrapper">
                <a href="javascript:void(0)" class="down_ios btn-down trace-download">
                    <i class="icon-ios letsicon-apple" v-if="deviceType == 'ios'"></i>
                    <i class="icon-android letsicon-android" v-else></i>
                    <span @click="downloadKP(deviceType)">{{ deviceType }} 版下载</span>
                </a>
                <div class="down-wrapper-other" @click="scrollToSection('down-bot-wrapper')">
                    <span> 其他平台下载 </span>
                </div>
            </div>
            <div class="right">
                <div class="appshow">
                    <img style="width: 90%;margin-top: 1rem;margin-left: 4%;"
                        src="@/assets/img/imghome_right_zh.60e1c05c.60e1c05c.png">
                </div>
            </div>
        </div>
        <div class="m-AppAnimation">
            <div data-v-d3610756="" class="appAnimation mobile">
                <h1 class="zh">全球热门应用 “任您畅玩”</h1><svg width="400pt" height="340pt" viewBox="0,0,520,540"
                    preserveAspectRatio="xMidYMid meet" class="iehide showSvg">
                    <g class="blingcircle">
                        <circle cx="200pt" cy="240pt" r="60pt" stroke-width="2" stroke="rgba(100,128,253,0.15)"
                            fill="none">
                        </circle>
                        <circle cx="200pt" cy="240pt" r="100pt" stroke-width="2" stroke="rgba(100,128,253,0.1)"
                            fill="none">
                        </circle>
                        <circle cx="200pt" cy="240pt" r="150pt" stroke-width="2" stroke="rgba(100,128,253,0.05)"
                            fill="none"></circle>
                    </g>
                    <g class="bling blingcircle">
                        <image xlink:href="@/assets/img/speed_app_1.54d47b5a.png" x="100pt" y="330pt" width="140pt"
                            height="140pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;100pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;330pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_2.5dd0814b.png" x="100pt" y="100pt" width="80pt"
                            height="80pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;100pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;100pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_3.6b50eb2d.png" x="10pt" y="180pt" width="80pt"
                            height="80pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;10pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;180pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_4.5829ddd5.png" x="260pt" y="310pt" width="90pt"
                            height="90pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;260pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;310pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_5.217178c9.png" x="210pt" y="80pt" width="100pt"
                            height="100pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;210pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;80pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                        <image xlink:href="@/assets/img/speed_app_6.fdc25fa8.png" x="290pt" y="160pt" width="140pt"
                            height="140pt" class="svgimage">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;290pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="190pt;160pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </image>
                    </g>
                    <g class="bling blingcircle">
                        <defs>
                            <linearGradient id="redbot" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style="stop-color: rgb(234, 67, 53);"></stop>
                                <stop offset="100%" style="stop-color: rgb(234, 67, 53);"></stop>
                            </linearGradient>
                        </defs>
                        <defs>
                            <linearGradient id="bluebot" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style="stop-color: rgb(0, 102, 217); stop-opacity: 1;"></stop>
                                <stop offset="100%" style="stop-color: rgb(0, 102, 217); stop-opacity: 1;"></stop>
                            </linearGradient>
                        </defs>
                        <defs>
                            <linearGradient id="yellowbot" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" style="stop-color: rgb(255, 170, 69); stop-opacity: 1;"></stop>
                                <stop offset="100%" style="stop-color: rgb(255, 170, 69); stop-opacity: 1;"></stop>
                            </linearGradient>
                        </defs>
                        <circle cx="100pt" cy="130pt" r="4pt" fill="url(#bluebot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;40pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;100pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                        <circle cx="130pt" cy="280pt" r="6pt" fill="url(#yellowbot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;40pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;210pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                        <circle cx="300pt" cy="140pt" r="2pt" fill="url(#redbot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;40pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;210pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                        <circle cx="380pt" cy="240pt" r="4pt" fill="url(#bluebot)" class="elliptop">
                            <animate attributeName="x" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;260pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                            <animate attributeName="y" attributeType="XML" repeatCount="1" keyTimes="0;1"
                                values="200pt;140pt" begin="2.5s" dur="1s" fill="freeze"></animate>
                        </circle>
                    </g><svg width="600pt" height="600pt" x="-2pt" class="ellip">
                        <g>
                            <image xlink:href="@/assets/img/appAnimation.a744ae10.png" width="80pt" height="80pt"
                                x="162pt" y="197pt" class="hiddensvg enimgsvg svgimage"></image>
                        </g>
                    </svg>
                </svg>
            </div>
        </div>
        <div class="intro-wrapper">
            <div class="intro-item">
                <div class="desc-text">
                    <div class="tip_btn">
                        <img alt="" class="icon-desc-title" data-src="@/assets/img/home_title_img.a9313b31.png"
                            src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded">
                        <span>火爆卖点</span>
                    </div>
                    <h2><span>一键“鲲鹏”，纵享丝滑</span></h2>
                    <p>鲲鹏 VPN 采用全新内核，AI 智能连接，自动为您匹配全球最快的网络节点，只需要轻点“开启鲲鹏”，3秒之内，纵享丝绸般顺滑的冲浪体验。</p>
                </div><img alt="" class="icon-bottom" data-src="@/assets/img/home_introduce_1.4974b5ba.png"
                    src="@/assets/img/home_introduce_1.4974b5ba.png" lazy="loaded">
            </div>
            <div class="intro-item">
                <div class="desc-text">
                    <div class="tip_btn"><img alt="" class="icon-desc-title"
                            data-src="@/assets/img/home_title_img.a9313b31.png"
                            src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded"><span>火爆卖点</span></div>
                    <h2><span>天涯海角，无不可达</span></h2>
                    <p>鲲鹏 VPN 支持全球网络资源，无限制无记录的访问任何资源，同时使用最先进的技术帮助您抹除任何痕迹，真正实现天涯海角随处达。</p>
                </div><img alt="" class="icon-bottom" data-src="@/assets/img/home_introduce_2.8e9af5ce.png"
                    src="@/assets/img/home_introduce_2.8e9af5ce.png" lazy="loaded">
            </div>
            <div class="intro-item">
                <div class="desc-text">
                    <div class="tip_btn"><img alt="" class="icon-desc-title"
                            data-src="@/assets/img/home_title_img.a9313b31.png"
                            src="@/assets/img/home_title_img.a9313b31.png" lazy="loaded"><span>火爆卖点</span></div>
                    <h2><span>随用随享，永不套牢</span></h2>
                    <p>全球唯一一家敢提供短期会员的知名 VPN，安全稳定的同时致力于保障用户权益，随时想用，随时订购，永远不用担心跑路，永远不用担心被套牢。</p>
                </div><img alt="" class="icon-bottom" data-src="@/assets/img/home_introduce_3.63497ff8.png"
                    src="@/assets/img/home_introduce_3.63497ff8.png" lazy="loading">
            </div>
            <div class="intro-item">
                <div class="desc-text">
                    <div class="tip_btn"><img alt="" class="icon-desc-title"
                            data-src="@/assets/img/home_title_img.a9313b31.png"
                            src="@/assets/img/home_title_img.a9313b31.png" lazy="loading"><span>火爆卖点</span>
                    </div>
                    <h2><span>不限平台，无缝衔接</span></h2>
                    <p>鲲鹏 VPN 支持市面上所有主流的设备，只需一个账号即可在多个设备中共享会员，支持多设备同时在线，保障您不同使用场景下的无缝衔接。</p>
                </div><img alt="" class="icon-bottom" data-src="@/assets/img/home_introduce_4.82a6475d.png"
                    src="@/assets/img/home_introduce_4.82a6475d.png" lazy="loading">
            </div>
            <div class="intro-item">
                <div class="desc-text">
                    <div class="tip_btn"><img alt="" class="icon-desc-title"
                            data-src="@/assets/img/home_title_img.a9313b31.png"
                            src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                            lazy="loading"><span>火爆卖点</span></div>
                    <h2><span>真人客服，永不失联</span></h2>
                    <p>鲲鹏 VPN 提供 24 小时在线服务，100+ 真人客服与网络工程师随时待命，为您上网体验保驾护航，真真正正的提供随叫随到，永不失联的 VIP 服务。</p>
                </div><img alt="" class="icon-bottom" data-src="@/assets/img/home_introduce_5.8e475357.png"
                    src="@/assets/img/home_introduce_5.8e475357.png" lazy="loading">
            </div>
        </div>
        <div class="comments">
            <div class="main-content clearfix">
                <h3 class="com-title">用户评价</h3>
                <!-- 用戶評價輪播 -->
                <div class="carousel-wrapper pc-comments-car">
                    <p class="comments">{{ comment }}</p>
                    <div class="carousel-container">
                        <span class="nav-arrow car-left" @click="changeSwiper(-1)"></span>
                        <span class="nav-arrow car-right" @click="changeSwiper(1)"></span>
                        <div class="carousel-ul-wrapper">
                            <ul class="carousel-content clearfix" :style="customStyles_mobile">
                                <li :data-index="index" class="carousel-item" style="width: 101.333px;"
                                    v-for="(item, index) in userComments" :key="index"
                                    :class="{ 'active': index == activeIndex }">
                                    <img :src="require('@/assets/user/' + item.img + '.png')" lazy="loading">
                                </li>
                                <li :data-index="index_1 + 27" class="carousel-item" style="width: 101.333px;"
                                    v-for="(item, index_1) in userComments" :key="index_1 + 27"
                                    :class="{ 'active': index_1 + 27 == activeIndex }">
                                    <img :src="require('@/assets/user/' + item.img + '.png')" lazy="loading">
                                </li>
                                <li :data-index="index_2 + 54" class="carousel-item" style="width: 101.333px;"
                                    v-for="(item, index_2) in userComments" :key="index_2 + 54"
                                    :class="{ 'active': index_2 + 54 == activeIndex }">
                                    <img :src="require('@/assets/user/' + item.img + '.png')" lazy="loading">
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="user-info">
                        <p>{{ user }}</p>
                        <p>{{ userCome }}</p>
                    </div>
                </div>
                <div ref="down-bot-wrapper" class="cont">
                    <h3>立即免费试用</h3>
                    <div class="subcont" v-show="deviceType == 'ios'">
                        <a href="javascript:void(0)" class="btn-down down_ios trace-download"
                            @click.prevent="downloadKP('ios')">
                            <i class="icon-ios"></i>
                            <span>iOS 版下载</span>
                        </a>
                    </div>
                    <div class="subcont" v-show="deviceType == 'android'">
                        <a href="javascript:void(0)" class="btn-down down_ios trace-download"
                            @click.prevent="downloadKP('android')">
                            <i class="icon-android"></i>
                            <span>Android 版下载</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <footer>
            <div class="content topline">
                <div class="down-platform">
                    <h3>多平台下载</h3>
                    <a href="javascript:void(0)" itemprop="operatingSystem" class="down_windows btn-down trace-download"
                        @click.prevent="downloadKP('windows')">
                        <span>PC 版本</span>
                    </a>
                    <a href="javascript:void(0)" itemprop="operatingSystem" class="down_android btn-down trace-download"
                        @click.prevent="downloadKP('android')">
                        <span>Android 版本</span>
                    </a>
                    <a href="javascript:void(0)" itemprop="operatingSystem" class="btn-down down_ios trace-download"
                        @click.prevent="downloadKP('ios')">
                        <span>iOS 版本</span>
                    </a>
                    <a href="javascript:void(0)" itemprop="operatingSystem" class="down_mac btn-down trace-download"
                        @click.prevent="downloadKP('macos')">
                        <span>Mac 版本</span>
                    </a>
                </div>
                <div class="about">
                    <h3>关于鲲鹏</h3>
                    <a href="" target="_blank" class="helpCenter"> 帮助中心 </a>
                    <a href="" class="termservice">服务条款</a>
                    <a href="" class="privacy">隐私权政策</a>
                    <a href="" class="registerterm">注册协议</a>
                </div>
            </div>
            <div class="bottom">
                <div class="contact">
                    <a href="">
                        <img src="@/assets/img/email.2e4e9014.svg" alt="">
                    </a>
                    <a href="" target="_blank">
                        <img src="@/assets/img/twitter.9b53da9a.svg" alt="">
                    </a>
                    <a href="" target="_blank">
                        <img src="@/assets/img/ins.6c93479c.svg" alt="">
                    </a>
                </div>
                <!-- <div class="ls-select-lng lng-size-small mobile">
                    <label for="lngtel" style="color: rgb(116, 126, 139);"><i class="icon-global"></i></label>
                    <select name="lngtel" id="lngtel" style="color: rgb(116, 126, 139);">
                        <option value="zh"> 简体中文 </option>
                        <option value="en"> English </option>
                        <option value="zh-tw"> 繁體中文 </option>
                        <option value="ru"> Русский </option>
                    </select>
                    <span class="caret" style="color: rgb(116, 126, 139);"></span>
                </div> -->
            </div>
        </footer>
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
export default {
    data() {
        return {
            deviceType: "",
            activeIndex: 29,
            timer: null,
            havaAin: true,
            userComments: [
                {
                    commnet: "相对于榜首的各大软件，价格相对而言算是便宜。下载后就像看见新大陆一样，十分好用，希望可以继续保留住这块净土和小确幸，直到阳光照到你们~",
                    img: "user1",
                    name: "18岁少年",
                    txt: "Appstore",
                },
                {
                    commnet: "雪中送炭呀，特别赞，对于我这个需要经常翻墙的人简直就是救星，看1080p的YouTube视频毫无压力，也不限速，非常好。",
                    img: "user2",
                    name: "clapclap family",
                    txt: "Google play",
                },
                {
                    commnet: "用着非常棒，界面看着好舒服，也没有广告很良心，一个月才24块，感谢又能让我联系到facebook上的朋友了，用来玩外服游戏也很顺畅。",
                    img: "user3",
                    name: "Star Moon",
                    txt: "个人用户",
                    isdef: true,
                },
                {
                    commnet: "简单好用速度快，简直神奇，连接速度极快，玩坦克世界闪电战贼稳，断了还能自动连接,这个vpn帮了大忙了。",
                    img: "user4",
                    name: "你的英雄～",
                    txt: "Appstore",
                },
                {
                    commnet: "终于找到了，竟然还没有流量限制，每天都离不开google和YouTube，最最最大的福利是tumblr看视频一点都不卡，老司机懂的！",
                    img: "user5",
                    name: "Google 用户",
                    txt: "Google play",
                },
                {
                    commnet: "快连这个软件非常良心，界面操作简便不繁琐一用就会了，链接速度稳定不断线，看视频打游戏都很好用，偶尔上ins找我的男神表白，太爽了。",
                    img: "user6",
                    name: "芒果味的小仙女",
                    txt: "个人用户",
                },
                {
                    commnet: "我覺得這個軟件非常的好，也不知道為什麼，我覺得他的界面十分的整潔，讓我看的一目了然，不像某些vpn軟件說的挺好，可是用起來卻不行，我覺得以後我是不會卸載這款vpn軟件了。",
                    img: "user7",
                    name: "Alexa Vega",
                    txt: "Google play",
                },
                {
                    commnet: "真的是很棒了 價格能接受 速度超級快的vpn 不出意外會一直用下去的 服務器也很穩定 棒棒噠。",
                    img: "user8",
                    name: "Rajesh Kapur",
                    txt: "Google play",
                },
                {
                    commnet: "作者簡直太良心了，速度比同類軟件快上不止一倍啊，用過最好最舒心的vpn，給作者一個大大的讚！",
                    img: "user9",
                    name: "Nazmin Islam",
                    txt: "Google play",
                },
                {
                    commnet: "一直在用快連vpn，網絡挺穩定的，一直以為這些軟件都是一樣卡頓，快連就是不一樣，好軟件，超信賴！也推薦給了朋友了，一直都用這個，好評！ ！ ！",
                    img: "user10",
                    name: "Abir Mahmud",
                    txt: "Google play",
                },
                {
                    commnet: "This app is really super strong! Big push. NetEase Cloud Gray Song all turn black can listen, do not exaggerate.",
                    img: "user11",
                    name: "culminal enterograph",
                    txt: "Google play",
                },
                {
                    commnet: "it's been seamless running on my Huawei Mate 20 phone. I don't feel any wall at all. I tested this app with my previous provider Fatiaoyun. Lets VPN is a clear winner on speed and connectivity.",
                    img: "user12",
                    name: "Min-John Lee",
                    txt: "Google play",
                },
                {
                    commnet: "Download a bunch of software can not be connected to the mainland, only this will not have to pay, so I am also very happy to pay a little reward amount, thank you this VPN so that I can use a lot of music app to listen to songs, there is support for Google payment, powerful.",
                    img: "user13",
                    name: "WNFGi KPpNn",
                    txt: "Google play",
                },
                {
                    commnet: "Extremely powerful! Mom no longer have to worry I can't see the limit TV series!",
                    img: "user14",
                    name: "iCOZp vZyQD",
                    txt: "Google play",
                },
                {
                    commnet: "Super easy to use VPN some can only look at the anime in China ヽ (´∀ ') Hinoko anime fans to express a satisfaction.",
                    img: "user15",
                    name: "阿憲",
                    txt: "Google play",
                },
                {
                    commnet: "Единственное приложение работающее в Туркмении, открывает инстаграм, вк, твитер и все заблокированные сайты. Мне нравится",
                    img: "user16",
                    name: "анонимное",
                    txt: "Google play",
                },
                {
                    commnet: "Приложение харошое! Самое главное в нём, что оно работает в ТМ!) Всем советую скачивать это приложение! Большое спасибо разработчикам!!!",
                    img: "user17",
                    name: "Nurik Seidov",
                    txt: "Google play",
                },
                {
                    commnet: "Всё хорошо работает даже супер👍",
                    img: "user18",
                    name: "анонимное",
                    txt: "Google play",
                },
                {
                    commnet: "Super! Thank you for programmer! Tm-da işleýär.",
                    img: "user19",
                    name: "Batyr Gylyjow",
                    txt: "Google play",
                },
                {
                    commnet: "Самый лучший ВПН супер",
                    img: "user20",
                    name: "Amangeldi G",
                    txt: "Google play",
                },
                {
                    commnet: "Благодарю разработчиков за данный впн",
                    img: "user21",
                    name: "Фран__ _Тихан",
                    txt: "Google play",
                },
                {
                    commnet: "I gowy vpn gatygowysowzözok i bet bet vpn",
                    img: "user22",
                    name: "Selim Suleymanow",
                    txt: "Google play",
                },
                {
                    commnet: "عالیه.اگه خوب بمونه واین بی ناموسافیلترش نکن خامنه ای حرام زاده",
                    img: "user23",
                    name: "محسن محسنی",
                    txt: "Google play",
                },
                {
                    commnet: "عالیه دان کنید",
                    img: "user24",
                    name: "دزدان دریایی جک گنجشکه",
                    txt: "Google play",
                },
                {
                    commnet: "ایول داری اپی🔊🌹",
                    img: "user25",
                    name: "ناشناس",
                    txt: "Google play",
                },
                {
                    commnet: "Normalno 1 gun bolsada bolya😆",
                    img: "user26",
                    name: "anoniman",
                    txt: "Google play",
                },
                {
                    commnet: "Cok guzel tkmda calisyor 👊👊👊",
                    img: "user27",
                    name: "anonim",
                    txt: "Google play",
                },
            ]
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    mounted() {
        this.getDeviceInfo_Mobile()
        this.timer = setInterval(() => {
            this.havaAin = true
            if (this.activeIndex == 56 || this.activeIndex == 2) {
                this.havaAin = false
                this.activeIndex = 29
            }
            this.activeIndex++
        }, 1500);
    },
    computed: {
        comment() {
            if (this.activeIndex <= 26) {
                return this.userComments[this.activeIndex].commnet
            } else if (this.activeIndex > 26 && this.activeIndex <= 53) {
                return this.userComments[this.activeIndex - 27].commnet
            } else if (this.activeIndex > 53 && this.activeIndex <= 80) {
                return this.userComments[this.activeIndex - 54].commnet
            }
        },
        user() {
            if (this.activeIndex <= 26) {
                return this.userComments[this.activeIndex].name
            } else if (this.activeIndex > 26 && this.activeIndex <= 53) {
                return this.userComments[this.activeIndex - 27].name
            } else if (this.activeIndex > 53 && this.activeIndex <= 80) {
                return this.userComments[this.activeIndex - 54].name
            }
        },
        userCome() {
            if (this.activeIndex <= 26) {
                return this.userComments[this.activeIndex].txt
            } else if (this.activeIndex > 26 && this.activeIndex <= 53) {
                return this.userComments[this.activeIndex - 27].txt
            } else if (this.activeIndex > 53 && this.activeIndex <= 80) {
                return this.userComments[this.activeIndex - 54].txt
            }
        },
        customStyles_mobile() {
            var moveWith = '-101.333'
            var nowWith = moveWith * (this.activeIndex - 2) - 100 //初始位置
            if (this.havaAin) {
                return {
                    'transition-duration': '300ms',
                    transform: `translate3d(${nowWith}px, 0px, 0px)`
                };
            } else {
                return {
                    'transition-duration': '0ms',
                    transform: `translate3d(${nowWith}px, 0px, 0px)`
                };
            }
        },
        customStyles() {
            var moveWith = '-231.2'
            var nowWith = moveWith * (this.activeIndex - 2) - 40 //初始位置
            if (this.havaAin) {
                return {
                    'transition-duration': '300ms',
                    transform: `translate3d(${nowWith}px, 0px, 0px)`
                };
            } else {
                return {
                    'transition-duration': '0ms',
                    transform: `translate3d(${nowWith}px, 0px, 0px)`
                };
            }

        }
    },
    methods: {
        scrollToSection(ref) {
            VueScrollTo.scrollTo(this.$refs[ref], 600, {
                easing: "down-bot-wrapper",
            });
        },
        changeSwiper(num) {
            clearInterval(this.timer)
            this.havaAin = true
            if (this.activeIndex == 56 || this.activeIndex == 2) {
                this.activeIndex = 29
                this.havaAin = false
            }
            this.activeIndex += num
            this.timer = setInterval(() => {
                this.havaAin = true
                if (this.activeIndex == 56 || this.activeIndex == 2) {
                    this.activeIndex = 29
                    this.havaAin = false
                }
                this.activeIndex++
            }, 1500);
        },
        downloadKP(device) {
            const { agent_code, share_id } = this.$route.query;
            const code = agent_code ? agent_code : '888'
            const share = share_id ? share_id : ''
            console.log(this.$route.query)
            switch (device) {
                case 'windows':
                    this.downloadFile(window.StaticConfig.pc_download + `?code=${code}&share_id=${share}`)
                    break;
                case 'macos':
                    this.downloadFile(window.StaticConfig.mac_download)
                    break;
                case 'android':
                    ShareTrace.preDownload()
                    this.downloadFile(window.StaticConfig.android_download)
                    break;
                case 'ios':
                    ShareTrace.preDownload()
                    this.$router.push('/iosdownload')
                    break;
                default:
                    break;
            }
        },
        //文件下载
        downloadFile(url) {
            if (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.match(/Trident.*rv\:11\./)) {
                // IE 浏览器，使用传统导航方式
                window.location.href = url;
            } else {
                // 其他现代浏览器，使用 HTML5 下载属性
                const link = document.createElement("a");
                link.href = url;
                link.target = "_self";
                link.download = true;

                link.dispatchEvent(
                    new MouseEvent("click", {
                        bubbles: true,
                        cancelable: true,
                        view: window,
                    })
                );
            }
        },
        //移动端判断
        getDeviceInfo_Mobile() {
            const userAgent = navigator.userAgent.toLowerCase();
            const isIOS = /iphone|ipad|ipod/.test(userAgent);
            const isAndroid = /android/.test(userAgent);

            if (isIOS) {
                this.deviceType = 'ios';
            } else if (isAndroid) {
                this.deviceType = 'android';
            } else {
                this.deviceType = 'android';
            }
        }
    }
}
</script>

<style scoped>
@import url(../assets/css/index.css);
</style>